<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <v-container
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  name: 'Container'
}
</script>
